import React from "react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import { compose, setPropTypes } from "recompose";
import { withRouter } from "react-router";
import { defineMessages, injectIntl } from "react-intl";
import qs from "web/core/utils/queryString";
import Icon from "theme/components/atoms/Icon";

const messages = defineMessages({
  previous: {
    id: "components.molecules.Paginator.previous",
    defaultMessage: "Previous",
  },
  next: {
    id: "components.molecules.Paginator.next",
    defaultMessage: "Next",
  },
});

const Paginator = (props) => {
  const buildPageUrl = (selectedPage) => {
    const { pathname, search } = props.location;
    const query = { ...qs.parse(search), page: selectedPage };
    return `${pathname}?${qs.stringify(query)}`;
  };

  const handlePageClick = (data) => {
    const { history } = props;
    const url = buildPageUrl(data.selected + 1);
    history.push(url);
  };

  return (
    <div className="paginator">
      <div className="paginator__wrapper">
        <ReactPaginate
          previousLabel={
            <Icon
              icon="chevron-left"
              title={props.intl.formatMessage(messages.previous)}
              size="tiny"
            />
          }
          nextLabel={
            <Icon
              icon="chevron-right"
              title={props.intl.formatMessage(messages.next)}
              size="tiny"
            />
          }
          breakLabel={<span className="paginator__li">…</span>}
          pageCount={props.maxPage}
          forcePage={props.page - 1}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          activeClassName={"active"}
          disabledClassName={"disabled"}
          hrefBuilder={buildPageUrl}
          containerClassName={"pagination"}
        />
      </div>
    </div>
  );
};

export default compose(
  setPropTypes({
    maxPage: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
  }),
  withRouter,
  injectIntl
)(Paginator);
